/*
 * @Author: cn1994
 * @Date: 2022-03-16 18:53:50
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-13 13:46:26
 * @Description: file content
 */
import Vue from "vue";
import VueRouter from "vue-router";
import localforage from 'localforage'
const dataCenterBase = localforage.createInstance({
  name: 'dataCenterBase'
})
import dayjs from 'dayjs'

const packageConfig = require('../../package.json')

import educational from "./educational";
import order from "./order";
import saleV2 from "./saleV2";//招生
import set from "./setting";//设置
import indexPage from "./indexPage"; //首页
import resource from "./resource"; //资源相关
import textbook from "./textbook"; //资源相关
import award from "./award"//积分兑奖

import evaluation from "./evaluation"; //测评中心
import apphome from "./apphome"; //app3.0
import remark from "./remark"; //课堂评价
// 2022年11月8日11:34:47
// 新增历史员工模块
import teachingProgress from './teachingProgress'//教务管理-授课进度
// 2023年1月17日10:50:18
// 新增登陆模块
import login from './login' // 登陆相关页面
import partJob from './partJob' // 兼职编辑课程相关页面
// 2023年1月18日16:56:54
// 新增示例模块
import examples from './examples'
// 2023年2月26日15:30:40
// 新增个人信息页面
import personInfo from './person'
// 企培预览页
import phonePreview from './phonePreview'
// 2023年3月15日10:11:37
// 新增任务中心模块
import taskCenter from './taskCenter'
// 2023年4月11日10:41:36
// 新增组织架构
import organizationManagement from './organizationManagement'; // 组织管理路由
import wechat from './wechat'; // 小程序路由
import iframePage from './iframePage'; // iframe页面
// 2023年8月2日16:20:02
// 新增校区和科目管理
import begin from './begin'
import live from './live'//直播

// 2023年9月14日10:34:30
// 整理规范新路由
import staff from './staff' // 员工相关
import member from './member' // 学员（成员）相关
import group from './group' // 班级相关,class是关键字，所有用group
import coursesManagementqp from './coursesManagementqp' // 企培课程管理页面
import taskDetail from './taskDetail' // 任务详情
import exportCenter from "./exportCenter";//导入导出的任务中心
import addApply from './addApply' // 加入申请
import createVideoDubbing from './createVideoDubbing' // 制作视频配音

import {checkVersion, checkLogin, loginByParams, getQuickBiData,ugcLoginToBook} from '../utils/index'

import {setWxConfig} from '../utils/wxConfig'
import {useWxConfigStore} from "../stores/wx";
import {useBaseStore} from "@/stores/base";

// 2023年12月11日16:14:17
// 新增数据中心v2版本，采用quick bi方案
import dataCenterV2 from './dataCenterV2'


import medical from '@/router/medical/index'//医疗相关路由

// 2024年6月5日17:48:10
// 新增请假路由模块
import leave from './leave' // 请假模块
// 2024年7月24日15:17:56
// 新增编辑绘本模块
import pictureBook from './pictureBook'
// 2024年7月10日13:52:45
// 新增课时卡管理模块
import lessonCard from './lessonCard'
// 增值内容管理
import incrementContents from './incrementContents'

// 2024年11月14日17:47:41
// 新增约课管理模块
import appointment from './appointment'

import { useUserStore } from '@/stores/user'
import { useInstStore } from '@/stores/inst'

import lsForeign from '@/router/lsForeign/index.js'//领视外教相关路由
// 机构外教
import instForeign from './instForeign.js'//机构外教相关路由
import aiForeign from './aiForeign.js'//ai外教相关路由


const router = new VueRouter({
  routes: [
    {path: '404', component: () => import('../components/404.vue')},
    {
      path: '/appscanCode',
      // component: () => import('../pages/medical/medicalAppointment/scanCode.vue')
      component: () => import('../pages/medical/medicalAppointment/scanCode.vue')
    },
    {path: '/', redirect: '/login'},
    {
      path: '/iframeControRouter',
      name: 'iframeControRouter',
      component: () => import('../pages/dataCenterV2/iframeControRouter.vue'),
    },
    ...login,
    ...personInfo,
    ...phonePreview,
    ...begin,
    ...partJob,
    //首页
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '工作台'
      },
      component: () => import('../pages/menu/index.vue'),
      children: [
        ...indexPage,
        ...saleV2,
        ...staff,
        ...member,
        ...group,
        ...educational,
        ...evaluation,
        ...teachingProgress,
        ...remark,
        ...award,
        ...live,
        ...resource,
        ...textbook,
        ...set,
        ...apphome,
        ...organizationManagement,
        ...wechat,
        ...order,
        ...iframePage,
        ...taskCenter,
        ...coursesManagementqp,
        ...medical,//医疗相关路由
        ...taskDetail,
        ...exportCenter,//导入与导出的任务中心
        ...dataCenterV2,
        ...addApply,
        ...leave,
        ...examples,
        ...lessonCard,
        ...createVideoDubbing,
        ...pictureBook,
        ...appointment,
        ...incrementContents,
        ...lsForeign,// 领视外教路由
        ...instForeign,
        ...aiForeign,
      ]
    },
  ]
});

router.beforeEach(async (to, from, next) => {
  if (process.env.NODE_ENV != "development") {
    checkVersion()
  }

  let baseStore = JSON.parse(sessionStorage.getItem('baseStore'))
  //兼职平台跳转过来 路由拦截
  if (baseStore && baseStore.userInfo.jzUserId) {
    //可以访问路由的白名单
    let whiteListRoutes = ['/partJob/createCourse', '/pictureBook/edit','/partJob/createVideoDubbing','/partJob/createMusic','/mineMaterials/createVideoDubbing/editVideo']
    console.log(whiteListRoutes,whiteListRoutes.includes(to.path), '白名单结果值')
    if (whiteListRoutes.includes(to.path)) {
      next()
    } else {
      // 防止重定向到登录页时造成死循环
      if (to.path !== '/login') {
        localStorage.removeItem('token')
        next('/login')
      } else {
        next() // 如果已经在登录页，直接放行
      }
    }
  }
  if (from.fullPath == '/') {

    if ((!baseStore || baseStore.baseUrl == '') || to.query.loginSource) {
      // 第一层路由拦截，在这里初始化数据
      if (to.query.loginSource) {
        // 外部方式进入系统
        let loginSource = to.query.loginSource
        if (loginSource == 'pc') {
          // pc直播客户端进入系统
          sessionStorage.setItem('loginSource', to.query.loginSource)
          const params = {
            token: to.query.token,
            serverId: to.query.serverId,
            domain: to.query.domain,
            // logintype: to.query.logintype,
            loginSource: to.query.loginSource
          }
          let result = await loginByParams(params)
          if (result == 200) {
            // 免登录
            let path = '/home'
            if (to.query.openUserId && to.query.corpId) {
              path = `/home?openUserId=${to.query.openUserId}&corpId=${to.query.corpId}`
            }
            next(path)
          } else {
            localStorage.removeItem('token')
            next('/login')
          }
        } else if (loginSource == 'wxworkAuth') {
          // 企业微信授权登陆
          if (to.query.token) {
            localStorage.setItem('token', to.query.token)
            let result = await checkLogin()
            if (result == 200) {
              // 免登录
              next('/home')
            } else {
              localStorage.removeItem('token')
              next('/login')
            }
          }
        } else if (loginSource == '51tyty') {
          // 从51tyty跳转过来
          const params = {
            token: to.query.token,
            serverId: to.query.serverId,
            domain: to.query.domain,
            // logintype: to.query.logintype,
            loginSource: to.query.loginSource
          }
          let result = await loginByParams(params)
          if (result == 200) {
            // 免登录
            next('/home')
          } else {
            localStorage.removeItem('token')
            next('/login')
          }
        } else if (loginSource === 'isCode') {
          const params = {
            token: to.query.token,
            serverId: to.query.serverId,
            domain: to.query.domain,
            // logintype: to.query.logintype,
            loginSource: to.query.loginSource
          }
          if (
            !params.token &&
            params.serverId &&
            to.query.instId &&
            to.query.from === 'weChatMiniProgram'
          ) {
            next()
          } else {
            let result = await loginByParams(params)
            if (result === 200) {
              next()
            }
          }
        } else if (loginSource == 'smallScope') {
          // 小范围重定向过来的免登录
          const params = {
            token: to.query.token,
            serverId: to.query.serverId,
            domain: to.query.domain,
            // logintype: to.query.logintype,
            loginSource: to.query.loginSource
          }
          let result = await loginByParams(params)
          if (result == 200) {
            // 免登录
            next('/home')
          } else {
            localStorage.removeItem('token')
            next('/login')
          }
        } else if (loginSource == 'editBook' || loginSource == 'partJob') {
          await ugcLoginToBook(to.query.username||to.query.userName,to.query.serverId || null,to.query.bookOrder||null,to.query.userId||null)
          next()
        }
      } else {
        // 正常进入系统
        let token = localStorage.getItem('token')
        if (token && token != '') {
          // 如果本地有token，则走免登录
          let result = await checkLogin()
          if (result == 200) {
            // 免登录
            if (to.path == '/login') {
              next('/home')
            } else {
              // 用户进入数据中心需要去获取Buick bi的地址和相关信息
              if (to.path.includes('/dataCenterV2')) {
                await getQuickBiData(to)
              }
              next()
            }
          } else {
            localStorage.removeItem('token')
            next('/login')
          }
        } else {
          if (to.path == '/login') {
            next()
          } else {
            next('/login')
          }
        }
      }
    } else {
      // 用户进入数据中心需要去获取Buick bi的地址和相关信息
      if (to.path.includes('/dataCenterV2')) {
        await getQuickBiData(to)
      }
      next()
    }
  } else {
    // 用户进入数据中心需要去获取Buick bi的地址和相关信息
    if (to.path.includes('/dataCenterV2')) {
      await getQuickBiData(to)
    }
    next()
  }
})

router.afterEach(async (to, from, failure) => {
  const baseStore = useBaseStore();
  const userStore = useUserStore()
  const instStore = useInstStore()

  if (to.meta.volcengine) {

    try {
      // 设置config
      const uniqueUserId = `${userStore.serverId}_${userStore.userId}`
      window.collectEvent('config', {user_unique_id: uniqueUserId});

      window.collectEvent('bm_pageview', {
        bm_client_version: packageConfig.version,
        bm_page_path: to.path,
        bm_page_title: to.meta.title || '未设置名称',
        bm_page_view_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        bm_user_name: userStore.userName,
        bm_subject: instStore.subject,
        bm_role: userStore.role
      });
    } catch (error) {
      console.log(error)
    }

  }

  // 进登陆页面把indexdb存的quick bi地址清空
  if (to.path == '/login') {
    dataCenterBase.clear()
  }
  if (to.path.includes('/begin') && to.path != '/begin/dataCenterV2') {
    sessionStorage.removeItem('rlen')
  }

  const ua = navigator.userAgent.toLowerCase()
  //企业微信端
  if (/micromessenger/g.test(ua)) {
    const wxConfigStore = useWxConfigStore()
    const openUserId = to.query.openUserId || wxConfigStore.openUserId
    const corpId = to.query.corpId || wxConfigStore.corpId
    if (openUserId && corpId) {
      console.log('has openUserId && corpId')
      wxConfigStore.openUserId = openUserId
      wxConfigStore.corpId = corpId
      if (!wxConfigStore.wxready) {
        console.log('enterRequestWxConfig')
        wxConfigStore.wxready = await setWxConfig({openUserId, corpId})
      }
    }
  }

})

Vue.use(VueRouter)

export default router;
